// Fix for Bootstrap dropdowns in admin area
// Ensures navbar dropdowns work correctly with both Bootstrap and theme hover functionality

document.addEventListener('DOMContentLoaded', function () {
  // First, ensure Bootstrap dropdowns are properly initialized
  // This is especially important for navbar dropdowns that have data-toggle="dropdown"

  // Initialize all dropdowns with data-toggle="dropdown" using Bootstrap
  const bootstrapDropdowns = document.querySelectorAll('[data-toggle="dropdown"]');
  bootstrapDropdowns.forEach(function (dropdown) {
    // Ensure Bootstrap dropdown is properly initialized
    if (typeof $ !== 'undefined' && $.fn.dropdown) {
      $(dropdown).dropdown();
    }
  });

  // Handle non-Bootstrap dropdowns (if any exist)
  const nonBootstrapDropdowns = document.querySelectorAll('.dropdown-toggle:not([data-toggle="dropdown"])');

  nonBootstrapDropdowns.forEach(function (dropdown) {
    // Skip if this dropdown is in the navbar (navbar dropdowns are handled by Bootstrap + theme)
    if (dropdown.closest('.navbar-nav')) {
      return;
    }

    // Remove any existing event listeners that might interfere
    const newDropdown = dropdown.cloneNode(true);
    dropdown.parentNode.replaceChild(newDropdown, dropdown);

    // Add click handler for manual dropdown functionality
    newDropdown.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const dropdownMenu = this.nextElementSibling;
      const isOpen = dropdownMenu && dropdownMenu.classList.contains('show');

      // Close all other open non-navbar dropdowns
      document.querySelectorAll('.dropdown-menu.show').forEach(function (menu) {
        // Skip navbar dropdowns
        if (menu.closest('.navbar-nav')) {
          return;
        }
        if (menu !== dropdownMenu) {
          menu.classList.remove('show');
          const toggle = menu.previousElementSibling;
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Toggle current dropdown
      if (dropdownMenu && !isOpen) {
        dropdownMenu.classList.add('show');
        this.setAttribute('aria-expanded', 'true');
      } else if (dropdownMenu) {
        dropdownMenu.classList.remove('show');
        this.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Ensure navbar dropdowns work properly on mobile and with clicks
  // The theme dropdown.js handles hover on desktop, but we need to ensure clicks work
  const navbarDropdowns = document.querySelectorAll('.navbar-nav .dropdown-toggle[data-toggle="dropdown"]');

  navbarDropdowns.forEach(function (dropdown) {
    // Add click handler to ensure dropdowns work on mobile and with clicks
    dropdown.addEventListener('click', function (e) {
      // Don't prevent default - let Bootstrap handle it
      // But ensure the dropdown state is properly managed

      const dropdownMenu = this.nextElementSibling;
      if (dropdownMenu) {
        // Toggle aria-expanded for accessibility
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dropdown')) {
      // Close all open dropdowns
      document.querySelectorAll('.dropdown-menu.show').forEach(function (menu) {
        menu.classList.remove('show');
        const toggle = menu.previousElementSibling;
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // Prevent dropdown from closing when clicking inside dropdown menu
  document.addEventListener('click', function (e) {
    if (e.target.closest('.dropdown-menu') && !e.target.classList.contains('dropdown-item')) {
      e.stopPropagation();
    }
  });

  // Handle mobile dropdown behavior
  // On mobile, we want clicks to work properly
  function handleMobileDropdowns() {
    if (window.innerWidth < 992) {
      // On mobile, ensure all dropdowns work with clicks
      const allDropdowns = document.querySelectorAll('.dropdown-toggle[data-toggle="dropdown"]');
      allDropdowns.forEach(function (dropdown) {
        // Remove any theme hover events on mobile
        const clone = dropdown.cloneNode(true);
        dropdown.parentNode.replaceChild(clone, dropdown);

        // Re-initialize Bootstrap dropdown
        if (typeof $ !== 'undefined' && $.fn.dropdown) {
          $(clone).dropdown();
        }
      });
    }
  }

  // Handle resize events
  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleMobileDropdowns, 250);
  });

  // Initial mobile check
  handleMobileDropdowns();
});
